import {SaveButton} from '@/components/refinedev/action_buttons';
import StaffForm from './staff-form';
import CreateForm from '@/components/refinedev/pages/create-form';

const StaffCreate = () => {
  return (
    <CreateForm transformBeforeSave={StaffForm.transformBeforeSave}>
      <div className="max-w-xl mx-auto flex flex-col gap-y-4 ">
        <StaffForm />
        <SaveButton size="lg" className="self-end" />
      </div>
    </CreateForm>
  );
};

export default StaffCreate;
